export default __webpack_public_path__ + "static/media/globalProductDiscountAfterThreshold.668df5f5.webp";